document.addEventListener('DOMContentLoaded', () => {
  const sideItems = document.querySelectorAll('.side-pref-link__item');
  const areas = document.querySelectorAll('.shoplist-area');

  if (!sideItems.length || !areas.length) return;

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        const id = entry.target.id;
        const sideItem = document.querySelector(
          `.side-pref-link__item[data-target="${id}"]`
        );

        if (!sideItem) return;

        if (entry.isIntersecting) {
          sideItems.forEach(i => i.classList.remove('is-active'));
          sideItem.classList.add('is-active');
        }
      });
    },
    {
      root: null,
      rootMargin: '-50% 0px -50% 0px',
      threshold: 0
    }
  );

  areas.forEach(area => observer.observe(area));
});
